import { ModalProps } from "antd";

export const modalProps: ModalProps = {
  destroyOnClose: true,
  width: 800,
  maskClosable: false,
};
